/* eslint-disable no-undef */

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const closeMobileNav = () => {
  document.body.classList.remove('js-nav-active');
  document.documentElement.classList.remove('disable-scroll');

  const button = document.getElementById('nav-toggle');
  if (button) {
    button.classList.remove('is-active');
    button.setAttribute('aria-expanded', 'false');
  }
};

const getSpyLine = () => {
  const header = document.querySelector('.site-header');
  const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
  const sample = document.querySelector('.section, .hero');
  const scrollMargin = sample
    ? parseFloat(window.getComputedStyle(sample).scrollMarginTop)
    : 0;

  // Must be below the sticky header AND the scroll-margin used for hash jumps.
  return Math.max(headerBottom, scrollMargin || 0) + 48;
};

const initHeaderScroll = () => {
  const header = document.querySelector('.site-header');
  if (!header) {
    return;
  }

  const update = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
};

const initHomeLinks = () => {
  const links = document.querySelectorAll('.nav-primary a, .footer-menu a, .site-logo-link, .custom-logo-link');

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      let url;

      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      const samePage = url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
      if (!samePage || url.hash) {
        return;
      }

      event.preventDefault();
      closeMobileNav();
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
      window.history.pushState('', '', window.location.pathname);
    });
  });
};

const initScrollSpy = () => {
  const navLinks = Array.from(document.querySelectorAll('.nav-primary a.nav-link'));
  if (!navLinks.length) {
    return;
  }

  const sections = [
    { id: 'start', el: document.getElementById('start') || document.querySelector('.hero') },
    { id: 'leistungen', el: document.getElementById('leistungen') },
    { id: 'ueber-uns', el: document.getElementById('ueber-uns') },
    { id: 'referenzen', el: document.getElementById('referenzen') },
    { id: 'kontakt', el: document.getElementById('kontakt') },
  ].filter((section) => section.el);

  const linkForSection = (id) => navLinks.find((link) => {
    try {
      const url = new URL(link.href, window.location.origin);
      if (id === 'start') {
        return !url.hash || url.hash === '#start';
      }
      return url.hash === `#${id}`;
    } catch (error) {
      return false;
    }
  });

  const setCurrent = (id) => {
    navLinks.forEach((link) => {
      const item = link.closest('.menu-item');
      if (item) {
        item.classList.remove('is-current');
      }
    });

    const activeLink = linkForSection(id);
    if (activeLink) {
      const item = activeLink.closest('.menu-item');
      if (item) {
        item.classList.add('is-current');
      }
    }
  };

  let ticking = false;
  let lockedId = null;
  let unlockTimer = null;

  const measureActiveId = () => {
    const spyLine = getSpyLine();
    let currentId = sections[0].id;

    sections.forEach((section) => {
      if (section.el.getBoundingClientRect().top <= spyLine) {
        currentId = section.id;
      }
    });

    return currentId;
  };

  const update = () => {
    ticking = false;

    if (lockedId) {
      setCurrent(lockedId);
      return;
    }

    setCurrent(measureActiveId());
  };

  const unlock = () => {
    lockedId = null;
    window.clearTimeout(unlockTimer);
    update();
  };

  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      try {
        const url = new URL(link.href, window.location.origin);
        const id = url.hash ? url.hash.replace('#', '') : 'start';
        if (id === 'start' || sections.some((section) => section.id === id)) {
          lockedId = id;
          setCurrent(id);
          window.clearTimeout(unlockTimer);
          unlockTimer = window.setTimeout(unlock, 1200);
        }
      } catch (error) {
        // Ignore malformed hrefs.
      }
    });
  });

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scrollend', unlock);
  window.addEventListener('resize', onScroll);
};

const initReveals = () => {
  const items = document.querySelectorAll('.reveal');
  if (!items.length) {
    return;
  }

  if (prefersReducedMotion()) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  if (!('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      entry.target.classList.add('is-visible');
      obs.unobserve(entry.target);
    });
  }, {
    threshold: 0.14,
    rootMargin: '0px 0px -10% 0px',
  });

  items.forEach((item) => observer.observe(item));
};

const initHomepage = () => {
  initHeaderScroll();

  if (!document.querySelector('.hero') && !document.body.classList.contains('home')) {
    return;
  }

  initHomeLinks();
  initScrollSpy();
  initReveals();
};

export default initHomepage;
